/**
 * Extention for web3.js. Adds the namespaces "energi", "masternode" and "miner" to web3.
 * Public API extension
 *
 * Usage:
 *
 * Web3 = require('web3');
 * web3Extension = require('@energi/web3-ext');
 *
 * web3 = new Web3('https://nodeapi.test3.energi.network');
 * web3Extension.extend(web3);
 *
 * Having the extension in place, you can use methods like:
 * result = await web3.energi.someMethod();
 * result = await web3.masternode.someMethod();
 * result = await web3.nrg.someMethod();
 * amountWei = web3.utils.toWei('1', 'nrg'); // <- '1000000000000000000'
 *
 * Or when making a transaction to the Energi mainnet:
 *
 * Tx = require('ethereumjs-tx').Transaction;
 * energiTxCommon = await web3Extension.getTxCommon(web3);
 * tx = new Tx(rawTx, {common: energiTxCommon});
 *
 * <i>Copyright (c) 2020 Energi Cryptocurrency - https://energi.world</i><br>
 * BSD-3-Clause License
 *
 *
 * @module energi.js
 * @extends Web3
 * @class Web3.energi
 * @since 0.1.0
*/
var extendEnergi = require('./lib/energi'),
    extendMasternode = require('./lib/masternode'),
    extendNrg = require('./lib/nrg'),
    getTxCommon = require('./lib/energi-tx-common'),
    extendEnergiUnitMap = require('./lib/energi-unit-map');
/**
 * Takes a web3 instance and extends (upgrades) it so that the following namespaces are available:
 * web3.energi
 * web3.masternode
 * web3.miner
 *
 * Having the extension, you can use methods like:
 * result = await web3.energi.someMethod(arg).call();
 * result = await web3.masternode.someMethod(arg).call();
 * result = await web3.miner.someMethod(arg).call();
 *
 * @method extend
 * @param web3instance {Object} web3 instance
 * @since 0.0.1
 */


var extend = function extend(web3instance) {
  // make sure the user passed a web3 instance
  if (!web3instance || !web3instance.eth || typeof web3instance.extend !== 'function') {
    throw new Error('Energi.extends needs a web3 instance as argument');
  }

  try {
    extendEnergi(web3instance);
    extendMasternode(web3instance);
    extendNrg(web3instance);
    extendEnergiUnitMap(web3instance);
  } catch (err) {
    console.error(err);
  }
};

module.exports = {
  extend: extend,
  getTxCommon: getTxCommon
};